import React from 'react';
import ReactDOM from 'react-dom';
import RLookUp from "../../Form/RLookUp";

const ModalOverlay = (props) => {
  return <>
    <RLookUp
      id={props.id}
      callBackDataHandler={props.callBackDataHandler}
      modalHandler={props.modalHandler}
      // DarkColorMode ={"ON"}
    />
  </>;
}

const ModalToSelectCar = (props) => {
  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <ModalOverlay {...props}/>,
        document.getElementById('overlay-root')
      )}
    </React.Fragment>
  );
};

export default ModalToSelectCar;



